// Footer.jsx
'use client';

import React, { useEffect } from 'react';
import { usePathname } from 'next/navigation';

import { getSiteConfig } from '../../../config/sites';
import styles from '../../../styles/components/footer/footer.module.scss';
import InlineIcon from '../../../utils/icons/InlineIcon';

/**
 * Вградени, а не от каталога `Icons.jsx`: заради тези две икони целият каталог влизаше в
 * page chunk-а на началната страница (одит 2026-08-29). Пътищата са от
 * `generated/iconPaths.js`.
 */
const FACEBOOK_PATHS = [
  'M768 85.333h-128c-117.821 0-213.333 95.513-213.333 213.333v0 128h-128v170.667h128v341.333h170.667v-341.333h128l42.667-170.667h-170.667v-128c0-23.564 19.103-42.667 42.667-42.667v0h128z',
];

const INSTAGRAM_PATHS = [
  'M298.667 85.333h426.667c117.821 0 213.333 95.513 213.333 213.333v426.667c0 117.821-95.513 213.333-213.333 213.333h-426.667c-117.821 0-213.333-95.513-213.333-213.333v-426.667c0-117.821 95.513-213.333 213.333-213.333z',
  'M682.667 485.12c1.175 7.523 1.846 16.2 1.846 25.034 0 94.257-76.41 170.667-170.667 170.667s-170.667-76.41-170.667-170.667c0-94.257 76.41-170.667 170.667-170.667 8.834 0 17.511 0.671 25.983 1.965l-0.949-0.119c74.402 11.339 132.448 69.385 143.667 142.838l0.119 0.949z',
  'M746.667 277.333h0.427',
];

const site = getSiteConfig();

const Footer = () => {
  const pathname = usePathname();

  useEffect(() => {
    // Add or remove body class for project page (скриване на футър само на мобилно чрез CSS)
    const isProjectPage = pathname === '/project' || pathname === '/pages/project';
    if (isProjectPage) {
      document.body.classList.add('project-page');
    } else {
      document.body.classList.remove('project-page');
    }

    return () => {
      document.body.classList.remove('project-page');
    };
  }, [pathname]);

  // Use CSS to hide footer on project page on mobile instead of conditional rendering
  // This avoids hydration mismatch issues

  return (
    <footer className={styles.footer}>
      <div className={styles.footer__social}>
        {site.contact.socialFacebook && (
          <a
            href={site.contact.socialFacebook}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.footer__social_link}
            aria-label="Facebook"
          >
            <InlineIcon
              paths={FACEBOOK_PATHS}
              size={24}
              color="#000"
              className={styles.footer__social_icon}
            />
          </a>
        )}
        {site.contact.socialInstagram && (
          <a
            href={site.contact.socialInstagram}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.footer__social_link}
            aria-label="Instagram"
          >
            <InlineIcon
              paths={INSTAGRAM_PATHS}
              size={24}
              color="#000"
              className={styles.footer__social_icon}
            />
          </a>
        )}
      </div>
      <div className={styles.footer__copyright}>
        <p>&copy; All rights reserved {site.content.copyrightYear}</p>
      </div>
      <div className={styles.footer__links}>
        <a href="/pages/privacy" className={styles.footer__link}>
          Политика за поверителност
        </a>
        <a href="/pages/terms-conditions" className={styles.footer__link}>
          Общи условия
        </a>
      </div>
    </footer>
  );
};

export default Footer;
